import script from "./UpdTransportFee.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdTransportFee.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__